import {
  REPORT_A_PROBLEM_FAILED,
  REPORT_A_PROBLEM_START,
  REPORT_A_PROBLEM_SUCCESS,
} from 'constants/action-types/support';

export default (state, { type, payload }) => {
  switch (type) {
    case REPORT_A_PROBLEM_START:
      return {
        ...state,
        reportAProblem: {
          ...state.reportAProblem,
          loading: true,
          error: null,
        },
      };
    case REPORT_A_PROBLEM_FAILED:
      return {
        ...state,
        reportAProblem: {
          ...state.reportAProblem,
          error: payload,
          loading: false,
        },
      };
    case REPORT_A_PROBLEM_SUCCESS:
      return {
        ...state,
        reportAProblem: {
          ...state.reportAProblem,
          loading: false,
          reported: true,
        },
      };
    default:
      return null;
  }
};
